export const projectsContentStyle = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "center",
  minHeight: "90vh",
  padding: "5rem 1rem",
};
